import {ActionContext} from "vuex";
import {ContentState, getContentProvider, getCurrentContent} from "./content_module";
import {ContentComplement} from "../../../../presentation/views/content/helpers";

class ComplementState {
  complements: ContentComplement[] = [];
}

const state = new ComplementState();
type ContentComplementActionContext = ActionContext<ComplementState, ContentState>;

const mutations = {
  SET_COMPLEMENTS(state: ComplementState, complements: ContentComplement[]) {
    state.complements = complements;
  }
};

const actions = {
  async loadComplements(ctx: ContentComplementActionContext) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const complements = await provider.getAllComplements(content.id) ?? [];
      ctx.commit("SET_COMPLEMENTS", complements);
    } catch (e) {
      console.error("[loadComplements] Error getAllComplements ", e);
      throw e;
    }
  },
};

const getters = {
  complements: (state: ComplementState) => state.complements ?? [],
};

const modules = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules,
};